var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import InlineButton from '../../../ui/atoms/OnlineChatLink';
import styled from 'styled-components';
import DisputesImage from '../../../ui/atoms/DisputesImage';
import DisputeInfoModalHeaderText from '../../../ui/molecules/DisputeInfoModalHeaderText';
import query from 'syf-component-library/const/mediaQueries';
import { Body } from 'syf-component-library/ui/typography';
import { fontSizes, spacing } from 'syf-component-library/defaultTheme';
import theme from '../../../theme';
import i18n, { t } from '../../../strings/i18n/i18n';
import { TransactionStatus } from '../../../const/transactionStatus';
import getTranslationForTransactionDisputeTitle from '../../../helpers/getTranslationForTransactionDisputeTitle';
import getTranslationForTransactionDisputeDescription from '../../../helpers/getTranslationForTransactionDisputeDescription';
import { Trans } from 'react-i18next';
import { Analytics } from '../../../helpers/analyticsMiddleware';
import useWindowSize from 'syf-component-library/ui/customHooks/useWindowWidth';
import { shallowEqual, useSelector } from 'react-redux';
var TransactionStatusHeaderImageName = (_a = {},
    _a[TransactionStatus.SET_1] = 'MEDITATE',
    _a[TransactionStatus.SET_2] = 'MAGNIFY',
    _a[TransactionStatus.SET_3] = 'MAGNIFY',
    _a[TransactionStatus.SET_4] = 'MAGNIFY',
    _a[TransactionStatus.SET_5] = 'MEDIDATE_SUCCESS',
    _a[TransactionStatus.SET_6] = 'MEDIDATE_SUCCESS',
    _a[TransactionStatus.SET_7] = 'MEDIDATE_SUCCESS',
    _a[TransactionStatus.SET_8] = 'FILE',
    _a[TransactionStatus.SET_9] = 'CHECKMARK',
    _a[TransactionStatus.SET_10] = 'CHECKMARK',
    _a[TransactionStatus.SET_11] = 'CANCEL',
    _a[TransactionStatus.SET_12] = 'CHECKMARK',
    _a[TransactionStatus.SET_13] = 'CHECKMARK',
    _a[TransactionStatus.SET_14] = 'FILE',
    _a[TransactionStatus.SET_15] = 'FILE',
    _a[TransactionStatus.SET_16] = 'FILE',
    _a[TransactionStatus.SET_17] = 'FILE',
    _a[TransactionStatus.SET_18] = 'FILE',
    _a[TransactionStatus.SET_19] = 'CANCEL',
    _a[TransactionStatus.SET_20] = 'FILE',
    _a[TransactionStatus.SET_21] = 'CANCEL',
    _a[TransactionStatus.SET_22] = 'MAGNIFY',
    _a[TransactionStatus.SET_23] = 'CHECKMARK',
    _a);
var HeaderImageContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: ", "px;\n  margin-bottom: ", "px;\n"], ["\n  margin-top: ", "px;\n  margin-bottom: ", "px;\n"])), spacing.xxlarge, spacing.large);
var HeaderContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n"])));
var CaseDescriptionText = styled(Body)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-top: ", "px;\n  @media ", " {\n    max-width: 350px;\n  }\n"], ["\n  margin-top: ", "px;\n  @media ", " {\n    max-width: 350px;\n  }\n"])), spacing.small, query.lessThanMedium);
var DisputeStatusTitle = styled.h2(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-size: ", "px;\n  color: ", ";\n  @media ", " {\n    font-size: ", "px;\n  }\n"], ["\n  font-size: ", "px;\n  color: ", ";\n  @media ", " {\n    font-size: ", "px;\n  }\n"])), fontSizes.medium, theme.colors.lightBlack, query.lessThanMedium, fontSizes.medium);
var DisputeInfoHeaderContent = function (_a) {
    var additionalInfoEnabled = _a.additionalInfoEnabled, assetsURL = _a.assetsURL, caseStatus = _a.caseStatus, eligibleForRedispute = _a.eligibleForRedispute, handleLaunchChat = _a.handleLaunchChat, handleRedispute = _a.handleRedispute, handleUploadDocuments = _a.handleUploadDocuments;
    var redispute = useSelector(function (state) { return state; }, shallowEqual).featureFlags.redispute;
    var isRedispute = redispute && eligibleForRedispute;
    var imageName = TransactionStatusHeaderImageName[caseStatus] || 'CHECKMARK';
    var disputeStatusTitle = getTranslationForTransactionDisputeTitle(caseStatus);
    var disputeStatusDescription = getTranslationForTransactionDisputeDescription(caseStatus);
    var isLessThanTablet = useWindowSize().isLessThanTablet;
    var imageSize = isLessThanTablet ? 'xsmall' : 'small';
    return (_jsxs(HeaderContainer, { children: [_jsx(HeaderImageContainer, { children: _jsx(DisputesImage, { assetsHost: assetsURL, imageName: imageName, size: imageSize }) }), _jsx(DisputeStatusTitle, __assign({ "data-cy": "dispute-status-title" }, { children: t(disputeStatusTitle) })), disputeStatusDescription.map(function (description) { return (_jsx(CaseDescriptionText, { children: t(description) }, description)); }), isRedispute && (_jsx(CaseDescriptionText, __assign({ "data-cy": "redispute-verbiage" }, { children: _jsx(Trans, { i18n: i18n, i18nKey: "transactionDisputeStatusDescription.ifYouDisagree", components: [
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        _jsx(InlineButton, { "data-analytics": "clicktrackingevent", "data-object": "button", "data-type": "body", "data-reason": Analytics.RedisputeTransaction, onClick: handleRedispute }),
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        _jsx(InlineButton, { "data-analytics": "clicktrackingevent", "data-cy": "online-chat-link", "data-object": "button", "data-type": "online chat", onClick: handleLaunchChat }, "online chat")
                    ] }) }))), _jsx(DisputeInfoModalHeaderText, { additionalInfoEnabled: additionalInfoEnabled, handleUploadDocuments: handleUploadDocuments, handleLaunchChat: handleLaunchChat, transactionStatus: caseStatus })] }));
};
export default DisputeInfoHeaderContent;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=index.js.map